import { Component, HostBinding, Input, OnInit } from '@angular/core'

@Component({
    selector: 'ca-tooltip',
    template: `
        <aside class="component-tooltip {{classes}}">
            <h1 *ngIf="header">{{header}}</h1>
            <div class="component-tooltip-content">
                <div *ngIf="content" [innerHTML]="content"></div>
                <ng-content></ng-content>
            </div>
        </aside>`,
})
export class TooltipComponent implements OnInit {
    @Input() asideClass: string
    @Input() position: string
    @Input() header: string
    @Input() content: string
    @HostBinding('class.jsTooltipContainer') @Input() jsTooltip: boolean = false
    @HostBinding('style.left') @Input() left: string
    @HostBinding('style.top') @Input() top: string
    @HostBinding('style.width') @Input() width: string
    classes: string

    ngOnInit() {
        this.classes = this.getClassesFromPosition(this.position) + ' ' + this.asideClass
    }

    private getClassesFromPosition(position: string): string {
        switch (position) {
            case 'top':
                return 'positionedTop pointerBodyBottomLeft'
            case 'top-center':
                return 'positionedTopCenter pointerBodyBottomCenter'
            case 'top-left':
                return 'positionedTopLeft pointerBodyBottomLeft'
            case 'top-right':
                return 'positionedTopRight pointerBodyBottomRight'
            case 'bottom':
                return 'positionedBottom pointerHeaderTopLeft'
            case 'bottom-center':
                return 'positionedBottomCenter pointerHeaderTopCenter'
            case 'bottom-left':
                return 'positionedBottomLeft pointerHeaderTopLeft'
            case 'bottom-right':
                return 'positionedBottomRight pointerHeaderTopRight'
            case 'left':
                return 'positionedLeft pointerHeaderRight'
            case 'left-bottom':
                return 'positionedBottomLeft pointerHeaderRight'
            case 'right':
                return 'positionedRight pointerHeaderLeft'
            case 'body-left':
                return 'positionedBodyLeft pointerBodyRight'
            case 'body-right':
                return 'positionedBodyRight pointerBodyLeft'
            case 'center-right':
                return 'positionedCenter pointerBodyBottomRight'
            case 'right-left':
                return 'positionedRight pointerBodyBottomLeft'
            default:
                return ''
        }
    }
}